import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useTranslateKey } from "../../components/translation/useTranslateKey";
import {
  FaFire,
  FaStar,
  FaTags,
  FaHome,
  FaAddressBook,
  FaMapMarkerAlt,
  FaBuilding,
  FaPaperPlane,
  FaClock,
  FaMoneyBill,
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faBath,
  faVectorSquare,
  faCar,
  faSwimmingPool,
  faDumbbell,
  faShieldAlt,
  faParking,
  faTree,
  faChild,
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
  faComment,
  faPaperPlane,
  faUser,
  faSnowflake,
  faArchway,
  faWifi,
  faArrowUp,
  faAddressBook,
  faWater,
} from "@fortawesome/free-solid-svg-icons";

import {
  faWhatsapp,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import "./PropertyDetailsPage.css";
import axios from "axios";
import { useParams } from "react-router-dom";
// import Header from "../../components/Header/Header";
import { API_BASE_URL, IMAGES_BASE_URL } from "../../api/config";
import ImageSlider from "../../components/Modals/ImageSliderModal/ImageSliderModal";
import { LangContext } from "../../components/translation/langugeContext";
import PropertyCard from "../../components/Shared/PropertyCard";
import { useCurrency } from "../../components/Shared/CurrencyContext";
const schema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(/^[A-Za-z ]+$/, "Name must only contain letters and spaces"),

  email: Yup.string()
    .nullable()
    .notRequired()
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
      message: "Enter a valid email address example@mail.com",
      excludeEmptyString: true,
    }), //optional
  phone: Yup.string()
    .required("Mobile number is required")
    .matches(/^\d+$/, "Phone number must contain digits only")
    .matches(/^[0-9]{7,20}$/, "Enter a valid mobile number (7-20 digits)"),
  message: Yup.string(),
});
const PropertyDetailsPage = ({ projects, amenities }) => {
  const { currency } = useCurrency();
//console.log("currency from context:", currency);
  const { id } = useParams();
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [thumbImages, setThumbImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const t = useTranslateKey();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setIsMobile(isMobile);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
         const currencyCode = currency.code; 
        const res = await axios.get(`${API_BASE_URL}/property-detail/${id}/`, {
          params: { currency: currencyCode }
        });
        const images = res.data.property.images.map((img) => img.image);
        setPropertyDetails(res.data);
        setMainImage(images[0]);
        setThumbImages(images);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchDetails();
  }, [id, currency.code]);

  const handleThumbClick = (imgSrc) => {
    setMainImage(imgSrc);
  };

  const visibleThumbs = thumbImages.slice(0, 3);
  const remainingThumbs = thumbImages.length - 3;

  return (
    <section className="bg-[#11132F] text-white">
      {/* <Header routingFlag={true} /> */}
      <div className="container mx-auto px-4">
        {/* Property Gallery */}
        {!isMobile && (
          <>
            <div className="property-gallery mb-12">
              <div className="main-image h-96 rounded-xl overflow-hidden mb-4">
                <img
                  src={`${mainImage}`}
                  alt="Main"
                  className="w-full h-full object-cover"
                />
              </div>


              <div className="gallery-thumbs grid grid-cols-4 gap-4">
                {visibleThumbs.map((img, index) => (
                  <div
                    key={index}
                    className="thumb-image h-24 rounded-xl overflow-hidden cursor-pointer"
                    onClick={() => handleThumbClick(img)}
                  >
                    <img
                      src={`${img}`}
                      alt={`Thumb ${index}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}

                {thumbImages.length > 3 && (
                  <div
                    onClick={() => setShowModal(true)}
                    className="thumb-image relative h-24 rounded-xl overflow-hidden cursor-pointer"
                  >
                    <img
                      src={`${thumbImages[3]}`}
                      alt={`Thumb ${3}`}
                      className="w-full h-full object-cover "
                    />
                    <div className="show-more-overlay"></div>
                    <div className="absolute inset-0 flex items-center justify-center text-white font-bold text-lg z-10">
                      <a className="text-white hover:underline cursor-pointer">
                        +{remainingThumbs} {t("showMore")}
                      </a>
                    </div>
                  </div>
                )}

              </div>
            </div>
            <ImageSlider
             modalstyle={true}
              show={showModal}
              onClose={() => setShowModal(false)}
              thumbImages={thumbImages}
            ></ImageSlider>
          </>
        )}
        {isMobile && (
          <>
            <ImageSlider
              modalstyle={false}
              show={isMobile}
              onClose={() => setShowModal(false)}
              thumbImages={thumbImages}
            ></ImageSlider>
          </>
        )}

        {/* Property Content */}
        <div className="Property-Content gap-8">
          <div>
            {propertyDetails ? (
              <>
                <PropertyInfoCard
                  data={propertyDetails.property}
                  projects={projects}
                />
                <AmenitiesCard
                  amenities={propertyDetails.property.amenities}
                  allAmenities={amenities}
                />
              </>
            ) : (
              <div className="text-center py-12">{t("noDetailsFound")}.</div>
            )}
          </div>

          <div>
            <ContactAgentCard id={id} />
          </div>
        </div>
      </div>
    </section>
  );
};
// Property Info Card Component
const PropertyInfoCard = ({ data, projects }) => {
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);
    console.log("data:", data);
  return (
    <div className="property-info-card backdrop-blur-lg p-8 rounded-xl bg-white/5 border border-white/10">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <div className="flex items-center gap-4">
          <div className="text-accent-yellow font-bold text-3xl">
            {data.featured ? (
              <>
                <FaHome style={{ color: "#fff", display: "inline" }} />

                <span style={{ color: "#fff" }}>{t("featured")}</span>{" "}
                <span style={{ color: "#F9C835" }}>{t("property")}</span>{" "}
               

              </>
            ) : (
              <>
                <FaFire style={{ color: "#fff", display: "inline" }} />

                <span style={{ color: "#fff" }}>{t("hot")}</span>{" "}
                <span style={{ color: "#F9C835" }}>{t("offers")}</span>{" "}
               

              </>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <ContactButton
            icon={faWhatsapp}
            text={t("whatsApp")}
            href="https://wa.me/+201030282513"
            gradient="from-[#25D366]/80 to-[#128C7E]/80"
          />
          <ContactButton
            icon={faPhoneAlt}
            text={t("call")}
            href="tel:+201030282513"
            gradient="from-[#FF6B6B]/80 to-[#FF5252]/80"
          />
        </div>
      </div>

      <div className="text-gray-300 mb-8">
        {/* Location & Project */}
        <div className="flex flex-wrap items-center gap-6 mb-4">
          <div className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-accent-yellow text-xl" />
            <span className="text-lg">
              {t("locationLabel")}{" "}
              {lang === "ar"
                ? data.location_area.name_ar + " , " + data.location_area.city.name_ar
                : data.location_area.name_en + " , " + data.location_area.city.name_en}
            </span>
          </div>

          {data.project && (
            <div className="flex items-center gap-2">
              <FaBuilding className="text-accent-yellow text-xl" />
              <span className="text-lg">
                {t("projectLabel")}{" "}
                {(() => {
                  const project = projects.find((project) => project.id === data.project);
                  if (!project) return "";
                  return lang === "ar"
                    ? project.name_ar || project.name
                    : project.name;
                })()}
              </span>
            </div>
          )}
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-white">{lang==="ar"?data.title_ar:data.title}</h1>
      </div>

      {/* Payment Details Section*/}
      <div className="bg-white/5 rounded-xl p-6 mb-6">
        <h3 className="text-xl font-bold text-accent-yellow mb-4">
          {t("paymentDetails")}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <>
            <PaymentDetailItem
              label={t("totalPriceLabel")}
              value={
                Number(data.display_price).toLocaleString("en-US") + " " + data.display_currency
              }
            />
            <PaymentDetailItem
              value={
                data.payment_plan === "cash" ? (
                  <label
                    htmlFor={`cashPayment-${data.id}`}
                    className="cash-installment-lable cursor-pointer pl-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-all duration-300 primary-active"
                  >
                    <FaMoneyBill />
                    {t("cash")}
                  </label>
                ) : (
                  <label
                    htmlFor={`installmentPayment-${data.id}`}
                    className="cash-installment-lable cursor-pointer pl-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-all duration-300 primary-active "
                  >
                    <FaClock />
                    {t("installments")}
                  </label>
                )
              }
            />
          </>
          <>
            {data.display_original_price > 0 && (
              <PaymentDetailItem
                label={t("totalPriceLabel")}
                value={
                  <div
                    className="line-through"
                    style={{
                      color: "white",
                      textDecorationColor: "#FF0000",
                    }}
                  >
                    {Number(data.display_original_price).toLocaleString("en-US")}{" "}
                    {data.display_currency}
                  </div>
                }
              />
            )}

            {data.display_down_payment > 0 && (
              <PaymentDetailItem
                label={t("downPaymentLabel")}
                value={
                  Number(data.display_down_payment).toLocaleString("en-US") +
                  " " +
                  data.display_currency              }
                additional={
                  "(" + Math.round(data.down_payment_percentage) + "%)"
                }
                valueClassName="textred"
              />
            )}
            {data.display_monthly_installment > 0 && (
              <PaymentDetailItem
                label={t("monthlyInstallment")}
                value={
                  Number(data.display_monthly_installment).toLocaleString("en-US") +
                  " " +
                 data.display_currency
                }
                additional={
                  "Over " + data.installment_duration_years + " Years"
                }
              />
            )}
          </>
          
        </div>
      </div>

      {/* Property Features */}

      <div className="propert-details-container">
        <FeatureItem icon={faBed} value={data.bedrooms} label={t("bedrooms")} />
        <FeatureItem icon={faBath} value={data.bathrooms} label={t("bathrooms")}/>
        <FeatureItem icon={faVectorSquare} value={data.area} label={t("m2")} />
        <FeatureItem icon={faCar} value={data.garage}   label={t("parkingSpots")} />

      </div>

      {/* Description */}
      <div className="border-t border-white/10 pt-8">
        <h2 className="text-2xl font-bold text-accent-yellow mb-6">
          {t("description")}
        </h2>
        <div className="space-y-6">
          <p className="text-gray-300 text-lg leading-relaxed">
            {lang === "ar"
              ? data.description_ar || data.description
              : data.description}
          </p>
        </div>
      </div>
    </div>
  );
};

const PaymentDetailItem = ({ label, value, additional, valueClassName }) => (
  <div className="payment-detail-item">
    <div className="text-gray-400 mb-1">{label}</div>
    <div className={`text-2xl font-bold ${valueClassName || "text-white"}`}>
      {value}
    </div>
    {additional && (
      <div className="text-sm text-accent-yellow">{additional}</div>
    )}
  </div>
);

const FeatureItem = ({ icon, value, label }) => (
  <div className="feature-item flex flex-col items-center text-center bg-white/5  rounded-xl hover:bg-white/10 transition-all duration-300">
    <FontAwesomeIcon icon={icon} className="text-accent-yellow text-3xl mb-2" />
    <div className="flex flex-col items-center">
      <span className="text-2xl font-bold text-white">{value}</span>
      <span className="text-gray-300">{label}</span>
    </div>
  </div>
);

const ContactButton = ({ icon, text, href, gradient }) => (
  <a
    href={href}
    target="_blank"
    className={`bg-white/5 hover:bg-white/10 text-[#F9C835] hover:text-white px-6 py-3 rounded-lg transition-all duration-300 flex items-center gap-2 group relative overflow-hidden`}
  >
    <div
      className={`absolute inset-0 bg-gradient-to-r ${gradient} opacity-0 group-hover:opacity-100 transition-all duration-300`}
    ></div>
    <FontAwesomeIcon
      icon={icon}
      className="text-xl transform transition-all duration-300 relative z-10 group-hover:scale-125 group-hover:rotate-12"
    />
    <span className="transform transition-all duration-300 relative z-10 group-hover:translate-x-1">
      {text}
    </span>
  </a>
);

// Amenities Card Component
const AmenitiesCard = ({ amenities, allAmenities }) => {
  const iconMap = {
    faSwimmingPool,
    faDumbbell,
    faShieldAlt,
    faParking,
    faTree,
    faChild,
    faSnowflake,
    faArchway,
    faWifi,
    faArrowUp,
    faWasher: faWater,
  };
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);
  return (
    <div className="property-info-card backdrop-blur-lg p-8 rounded-xl bg-white/5 border border-white/10">
      <h2 className="text-2xl font-bold text-accent-yellow mb-6">
        {t("amenities")}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {allAmenities
          .filter((amenity) => amenities.find((a) => amenity.id == a))
          .map((amenity) => (
            <div className="flex items-center gap-2">
              <FontAwesomeIcon
                icon={iconMap[amenity.icon]}
                className="text-accent-yellow text-xl"
              />
              <span className="text-lg">
                {lang === "ar" ? amenity.name_ar || amenity.name : amenity.name}{" "}
              </span>
            </div>
          ))}
      </div>
    </div>
  );
};

// Contact Agent Card Component
const ContactAgentCard = ({ id }) => {
  const t = useTranslateKey();
  return (
    <div className="contact-agent-card backdrop-blur-lg border border-accent-yellow/20 p-8 rounded-xl bg-white/5">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-primary-accent to-primary-darker p-8 -mx-8 -mt-8 mb-8 rounded-t-xl shadow-lg relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('pattern.png')] opacity-10"></div>
        <div className="relative z-10">
          <h3 className="text-2xl font-bold text-white mb-2">
            {t("contactAgent")}
          </h3>
          <p className="text-white/80">{t("contactAgentDiscription")}</p>
        </div>
      </div>

      <div className="space-y-8">
        {/* Quick Contact Section */}
        <div>
          <h4 className="text-lg font-semibold text-[#F9C835] mb-4 flex items-center">
            <FaAddressBook className="text-[#F9C835] text-xl mr-2" />
            {t("quickContact")}
          </h4>
          <div className="QuickContactButton ">
            <QuickContactButton
              icon={faWhatsapp}
              label={t("whatsApp")}
              href="https://wa.me/+201030282513"
              gradient="from-[#25D366]/80 to-[#128C7E]/80"
            />
            <QuickContactButton
              icon={faPhoneAlt}
              label={t("callNow")}
              href="tel:+201030282513"
              gradient="from-[#FF6B6B]/80 to-[#FF5252]/80"
            />
          </div>
        </div>

        {/* Contact Form */}
        <div className="pt-4">
          <h4 className="text-lg font-semibold text-[#F9C835] mb-6 flex items-center">
            <FaStar className="!text-[#F9C835] text-xl mr-2" />
            {t("sendMessage")}
          </h4>
          <ContactForm id={id} />
        </div>

        {/* Privacy Note */}
        <p className="text-sm text-white/60 text-center">
          {t("contactAgentEndMassage")}
        </p>
      </div>
    </div>
  );
};

const QuickContactButton = ({ icon, label, href, gradient }) => (
  <a
    href={href}
    target="_blank"
    className="flex flex-col items-center justify-center gap-2 bg-white/5 p-4 rounded-xl transition-all duration-300 hover:bg-white/10 group relative overflow-hidden"
  >
    <div
      className={`absolute inset-0 bg-gradient-to-r ${gradient} opacity-0 group-hover:opacity-100 transition-all duration-300`}
    ></div>
    <div className="nav-icon-circle w-16 h-16 flex items-center justify-center rounded-full transition-all duration-300 relative z-10">
      <FontAwesomeIcon
        icon={icon}
        className="text-3xl text-[#F9C835] transform transition-all duration-300 group-hover:text-white group-hover:scale-125 group-hover:rotate-12"
      />
    </div>
    <span className="text-sm font-medium text-[#F9C835] group-hover:text-white transition-colors duration-300 relative z-10">
      {label}
    </span>
  </a>
);

const ContactForm = ({ id }) => {
  const t  = useTranslateKey();
  // State to store form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    property_id: id,
  });
  const schema = Yup.object().shape({
  name: Yup.string()
    .required(t("error.requiredName"))
    .matches(/^[\p{L} ]+$/u, t("error.nameOnlyLetters")),
  email: Yup.string()
    .nullable()
    .notRequired()
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
      message: t("error.invalidEmail"),
      excludeEmptyString: true,
    }),
  phone: Yup.string()
    .required(t("error.requiredPhone"))
    .matches(/^[\d٠-٩]+$/, t("error.phoneDigitsOnly"))
    .matches(/^[0-9٠-٩]{7,20}$/, t("error.invalidPhone")),
});


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  // State for loading and error handling
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Handle form submission

  const onSubmit = async (data) => {
    setLoading(true);
    setError(null);

    try {
      console.log(`${API_BASE_URL}/contact_property/${id}/`);
      const response = await axios.post(
        `${API_BASE_URL}/contact_property/`,
        { ...data, property_id: id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess(true);
      reset();
      // Hide success message after 4 seconds
      setTimeout(() => {
        setSuccess(false);
      }, 4000);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };


  return (
    <form className="space-y-6" noValidate onSubmit={handleSubmit(onSubmit)}>
      <div className="relative">
        <input
          type="text"

          placeholder={t("yourName")}

          

          {...register("name")}
          className="w-full bg-white text-gray-800 px-6 pr-12 py-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-accent-yellow/50 transition-all duration-300"
        />
        <FontAwesomeIcon
          icon={faUser}
          className=" form-icon absolute right-5 top-1/2 -translate-y-1/2 text-[#F9C835] text-lg"
        />
        {errors.name && (
          <div className="text-red-500">{errors.name.message}</div>
        )}
      </div>
      <div className="relative">
        <input
          type="email"
          placeholder={t("yourEmail")}
          {...register("email")}
          className="w-full bg-white text-gray-800 px-6 pr-12 py-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-accent-yellow/50 transition-all duration-300"
        />
        <FontAwesomeIcon
          icon={faEnvelope}
          className="form-icon absolute right-5 top-1/2 -translate-y-1/2 text-[#F9C835] text-lg"
        />

        {errors.email && (
          <div className="text-red-500">{errors.email.message}</div>
        )}
      </div>
      <div className="relative">
        <input
          type="tel"

          placeholder={t("yourPhone") }

          {...register("phone")}
          className="w-full bg-white text-gray-800 px-6 pr-12 py-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-accent-yellow/50 transition-all duration-300"
        />
        <FontAwesomeIcon
          icon={faPhoneAlt}
          className="form-icon absolute right-5 top-1/2 -translate-y-1/2 text-[#F9C835] text-lg"
        />
        {errors.phone && (
          <div className="text-red-500">{errors.phone.message}</div>
        )}
      </div>
      <div className="relative">
        <textarea
          type="tel"
          placeholder={t("yourMessage")}
          {...register("message")}
          className="w-full bg-white text-gray-800 px-6 pr-12 py-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-accent-yellow/50 transition-all duration-300"
        />
        <FontAwesomeIcon
          icon={faComment}
          className=" form-icon absolute right-5 top-1/2 -translate-y-1/2 text-[#F9C835] text-lg"
        />
        {errors.message && (
          <div className="text-red-500">{errors.message.message}</div>
        )}
      </div>

      {error && <div className="text-red-500">{error}</div>}


      {success && (
        <div className="text-green-500">{t("successMassage")}!</div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-[#11132F] text-white py-4 px-8 rounded-xl font-bold text-lg relative overflow-hidden group"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#F9C835] to-[#332D7E] opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#F9C835] to-[#332D7E] opacity-0 group-hover:opacity-30 blur-xl transition-all duration-500"></div>
        <div className="absolute -inset-1 bg-gradient-to-r from-[#F9C835] to-[#332D7E] rounded-xl opacity-30 group-hover:opacity-70 blur transition-all duration-500 group-hover:blur-md"></div>
        <span className="relative z-10 flex items-center justify-center gap-3 transition-all duration-500">
          <FaPaperPlane className="transform group-hover:translate-x-2 group-hover:-translate-y-2 group-hover:scale-125 transition-all duration-500" />
          <span className="group-hover:text-[#F9C835] transition-colors duration-500">
            {loading ? "Sending..." : t("sendMessage")}
          </span>
        </span>
      </button>
    </form>
  );
};

export default PropertyDetailsPage;
